import React from 'react';
import { AdminLayout, ChannelsAccessPermissionView, PolicyControlDecorated } from 'pages/administration.page';

export const ChannelAccessPageView = ({ policies, onChannelRightChange, rootChannels }) => (
  <AdminLayout>
    <div className="policies">
      {policies.map((policy, index) => (
        <PolicyControlDecorated policy={policy} key={index}>
          <div>
            {rootChannels.map((channel, index) => (
              <ChannelsAccessPermissionView
                channel={channel}
                policy={policy}
                onChange={onChannelRightChange}
                key={channel + index}
              />
            ))}
          </div>
        </PolicyControlDecorated>
      ))}
    </div>
  </AdminLayout>
);
